import { useEffect, useState } from "react";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import { usePageState } from "../../Layout";
import IconLoadingWave from "../../icons/IconLoadingWave";
import IconCheck from "../../icons/IconCheck";
import List from "../../components/List";
import Button from "../../components/Button";
import Spacer from "../../components/Spacer";
import FormInput from "../../components/FormInput";
import Message from "../../components/Message";
import UserCreate from "./UserCreate";
import UserEdit from "./UserEdit";

export default function Users() {
  const { pageState, setPageState } = usePageState();
  const [userData, setUserData] = useState(pageState.userData || null);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);

  const [loading, setLoading] = useState(false);

  const [addingNewUser, setAddingNewUser] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Get all users
  const getUsers = async () => {
    setLoading(true);
    await executeRequest(
      apiUrl + "users",
      "GET",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      async (data) => {
        setUsers(data);
      },
      (error) => {
        console.log(error);
      }
    );
    setLoading(false);
  };

  useEffect(() => {
    getUsers();
  }, []);

  // Render HTML
  if (addingNewUser) {
    return (
      <UserCreate
        userData={userData}
        onCancelled={() => setAddingNewUser(false)}
        onCreated={(data) => {
          getUsers();
          setAddingNewUser(false);
          setMessage("User successfully added.");
          setMessageType("success");
        }}
      />
    );
  }

  if (userToEdit !== null) {
    return (
      <UserEdit
        userData={userData}
        user={userToEdit}
        onCancelled={() => setUserToEdit(null)}
        onEditted={(data) => {
          getUsers();
          setUserToEdit(null);
          setMessage("User successfully updated.");
          setMessageType("success");
        }}
      />
    );
  }

  return (
    <div>
      <h1 className="page-title">Users</h1>
      <div className="flex flex-gap-m">
        <Button onClicked={() => setAddingNewUser(true)} text="Add new +" />
      </div>
      <Spacer />
      <List
        headers={
          userData.user_type === "customer"
            ? [
                "First name",
                "Last name",
                "Email",
                "Phone",
                "Applications",
                "Created at",
              ]
            : [
                "First name",
                "Last name",
                "Email",
                "Phone",
                "Role",
                "Applications",
                "Created at",
              ]
        }
        items={users}
        isLoading={loading}
        onEdit={(item) => setUserToEdit(item)}
        onDelete={(item) => setUserToDelete(item)}
      />

      {message.length > 0 && messageType.length > 0 && (
        <Message message={message} type={messageType} />
      )}
    </div>
  );
}
